import { fetchRestrictions } from "network/requests";
import { pathOr } from "ramda";
import React, { useCallback, useEffect, useGlobal, useState } from "reactn";

export const useGetOfficeRestrictions = ({ office }) => {
	const [restrictions, setRestrictions] = useState(null);
	const [user] = useGlobal("user");
	const token = pathOr(null, ["token"], user);

	const getRestrictions = useCallback(
		async (officeSlug) => {
			const response = await fetchRestrictions(officeSlug, token);
			const data = await response;
			return data;
		},
		[token]
	);

	useEffect(() => {
		if (!office || !token) return;
		const { slug } = office;
		getRestrictions(slug).then((restrictions) => {
			const userRestrictions = pathOr(
				null,
				["settings", "userRestrictions", "reservationLimitBy"],
				restrictions
			);
			setRestrictions({ userRestrictions });
		});
	}, [office, token]);
	return { restrictions };
};
